<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/promotion/memberMissionSummary")
          i.fa.fa-poll-h
          span.ml-1 {{ $t("ui.member_mission_summary") }}

  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row.mb-1
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')" @enter="getSummaryList(true)")
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getSummaryList(true)"
                    variant="success"
                    size="sm"
                    )
        div.card-body
          div.mb-1(v-if="pageLvl == 'summary'")
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.mb-1(v-if="pageLvl == 'detail'")
            div.mb-1
              SubmitButton(
                :loading="loading"
                icon="icon-arrow-left"
                :text="$t('ui.back')"
                type="button"
                @click="backToSummaryLvl"
                variant="secondary"
                size="sm"
                ).mb-1.mr-1
          div.row.clusterize
            div.col-md-12(v-if="pageLvl=='summary'")
              .clusterize-scroll
                table.tablex(style="width: 70%;")
                  thead
                    tr
                      th.sticky-position(width="5%")
                        span #
                      th.sticky-position.sortable(width="10%" @click="sortOrder('account_id')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('start_date')")
                        span(:title="$t('ui.start_date')") {{ $t('ui.start_date') }}
                        i(:class="changeSortKey('start_date')")
                      th.sticky-position.sortable(width="15%")
                        span(:title="$t('ui.end_date')") {{ $t("ui.end_date") }}
                      th.sticky-position.sortable(width="10%" @click="sortOrder('days')")
                        span(:title="$t('ui.days')") {{ $t("ui.days") }}
                        i(:class="changeSortKey('days')")
                  tbody.clusterize-content
                    tr(v-if="summaryList.length == 0")
                      td(colspan="5").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in summaryList")
                      td
                        span {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span(:title="item.account_id")
                          b-link.clickable(href="javascript:void(0);" @click="setMission(item)") {{ item.account_id }}
                      td
                        span(v-if="item.start_date" :title="$moment(item.start_date).format('YYYY-MM-DD')") {{ $moment(item.start_date).format('YYYY-MM-DD') }}
                      td
                        span(v-if="item.end_date" :title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format('YYYY-MM-DD') }}
                      td
                        span(:title="$n(item.days, 'integer')") {{ $n(item.days, 'integer') }}
            div.col-md-12(v-if="pageLvl== 'detail'")
              .clusterize-scroll
                table.tablex(style="width: 90%;")
                  thead
                    tr
                      th.sticky-position(width="5%")
                        span #
                      th.sticky-position.sortable(width="10%")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                      th.sticky-position.sortable(width="20%")
                        span(:title="$t('ui.start_date')") {{ $t('ui.start_date') }}
                      th.sticky-position.sortable(width="15%")
                        span(:title="$t('ui.deposit_date')") {{ $t('ui.deposit_date') }}
                      th.sticky-position.sortable(width="15%")
                        span(:title="$t('ui.deposit_amount')") {{ $t("ui.deposit_amount") }}
                      th.sticky-position.sortable(width="20%")
                        span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
                  tbody.clusterize-content
                    tr(v-if="detailList.length == 0")
                      td(:colspan="6").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in detailList")
                      td
                        span {{ (index + 1) }}
                      td
                        span(:title="item.account_id") {{ item.account_id }}
                      td
                        span(:title="$moment(item.start_date).format('YYYY-MM-DD')") {{ $moment(item.start_date).format('YYYY-MM-DD') }}
                      td
                        span(:title="$moment(item.deposit_date).format('YYYY-MM-DD')") {{ $moment(item.deposit_date).format('YYYY-MM-DD') }}
                      td
                        span(:title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
                      td
                        span(:title="item.remark") {{ item.remark }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    summaryList: [],
    detailList: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    pageLvl: 'summary',
    dateRange: {
      startDate: null,
      endDate: null
    },
    sortKey: "start_date",
    sortType: "desc",
    selectedMission: null,
    search: "",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  mounted: function() {
    this.getSummaryList();
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getSummaryList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    backToSummaryLvl() {
      this.pageLvl = "summary";
    },
    getSummaryList: function() {
      this.pageLvl = 'summary';

      let url = config.memberMissionSummaryUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '')
        json.member_id = this.search;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.summaryList = response.data.dt;
                this.totalRow = this.summaryList.length > 0 ? this.summaryList[0].totalrows : 0;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setMission: function (e) {
      this.selectedMission = e;
      this.detailList = [];
      this.getDetailList();
    },
    getDetailList: function() {
      let url = config.memberMissionDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.selectedMission.account_id,
        start_date: this.selectedMission.start_date,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pageLvl = 'detail';
                this.detailList = response.data.dt;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getSummaryList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getSummaryList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>